/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ChartNoAxesColumnIncreasing = [
  ["path", { d: "M5 21v-6" }],
  ["path", { d: "M12 21V9" }],
  ["path", { d: "M19 21V3" }]
];

export { ChartNoAxesColumnIncreasing as default };
//# sourceMappingURL=chart-no-axes-column-increasing.js.map
